import { computed, observable, action } from 'mobx';
import GdsModel from '~/glm/models/gds/gds-model';
import GdsInvitationModel from '~/glm/models/gds/gds-invitation-model';

export default class GdsGuestModel extends GdsModel {
  id;
  householdId;
  @observable firstName;
  @observable lastName;
  @observable phone;
  @observable email;
  @observable isLeader;
  @observable selected = false;
  @observable invitations = [];
  @observable giftList;
  toBeDestroyed = false;

  constructor(guest = {}, householdId = '') {
    super();
    this.id = guest.id;
    this.firstName = guest.firstName;
    this.lastName = guest.lastName;
    this.phone = guest.phone;
    this.email = guest.email;
    this.isLeader = guest.isLeader;
    this.householdId = householdId;
    this.selected = guest.selected;
    if (guest.invitations) {
      this.invitations = guest.invitations.map(
        invitation => new GdsInvitationModel(invitation, this.householdId, this.id)
      );
    } else if (guest.eventIds) {
      this.invitations = guest.eventIds.map(eventId => new GdsInvitationModel({ eventId }, this.householdId, this.id));
    }
  }

  @computed
  get apiEndpoint() {
    return `/v1/households/${this.householdId}/people${this.id ? `/${this.id}` : ''}`;
  }

  @computed
  get apiParams() {
    const invitations = this.invitations.map(val => val.apiParams);
    return {
      id: this.id,
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone,
      email: this.email,
      isLeader: this.isLeader,
      invitations,
    };
  }

  @action
  toggleSelected() {
    this.selected = !this.selected;
  }

  @action
  setSelected(bool) {
    this.selected = bool;
  }

  @computed
  get displayName() {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  getInvitationByEvent(eventId) {
    return this.invitations.find(invitation => invitation.eventId === eventId);
  }

  @action
  addInvitation = (invitation = {}, householdId, guestId) => {
    this.invitations.push(new GdsInvitationModel(invitation, householdId, guestId));
  };

  @action
  removeInvitation = (invitation = {}) => {
    this.invitations.remove(invitation);
  };
}
